import React from 'react';
import { Modal } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';

function CancellationNoteModal({
  show,
  onHide,
  onConfirm,
  title = "Confirm Delete",
  type
}) { 
  const validationSchema = Yup.object({
    cancellationNote: Yup.string()
      .required('Cancellation note is required')
      .trim(),
  });
 
  const formik = useFormik({
    initialValues: {
      cancellationNote: '',
    },
    validationSchema,
    onSubmit: (values) => {
      onConfirm(values.cancellationNote);  
    },
  });

  return (
    <Modal
      show={show}
      centered
      onHide={onHide}
      dialogClassName="el-deactivate-modal"
      >
      {/* backdrop="static" */}
      <Modal.Body  >
       
      <h5><b>{title}</b></h5>
        <form className="mt-4" onSubmit={formik.handleSubmit}>
          <div>
            <label htmlFor="cancellationNote">{type == 'cancel_appointment' ? 'Cancellation Reason' : 'Cancellation Note'}</label>
            <textarea
 
              id="cancellationNote"
              placeholder='Type here'
              name="cancellationNote"
              value={formik.values.cancellationNote}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="form-control mt-1"
            rows="4"
            />
            { formik.errors.cancellationNote && (
              <div className='text-danger mt-2'>{formik.errors.cancellationNote}</div>
            )}
          </div>
          <div className="d-flex my-3  mx-auto">
            <button type="submit" className="el-main-button">
              <span>{type == 'cancel_appointment' ? 'Cancel Appointment' : 'Cancel Request'}</span>
            </button>
            <button
              type="button"
              className="back-link ms-3"
              onClick={ ()=> {
                formik.resetForm();
                onHide();
              }}
            >
              Close
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default CancellationNoteModal;
